import {
  Avatar,
  Container,
  Grid,
  Heading,
  HStack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import bg from "../../../assets/course.webp";
import Layout from "../../../components/student/Layout/layout";
import { getSectionRequest } from "../../../modules/students-modules/sections/Actions";
const HomeworkChaptersList = () => {
  const { id } = useParams();
  const section = useSelector((state) => state.sections.section);
  const isLoading = useSelector((state) => state.sections.isLoading);

  const dispatch = useDispatch();
  useEffect(() => {
    if (id) dispatch(getSectionRequest(id));
  }, [id]);
  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      <Container maxW="container.2xl" h="100%" my="100px" mb="165px" w="100%">
        <VStack spacing={8} h="100%" w="100%" alignItems="flex-start">
          <Heading as="h3" color="main_1" textAlign="center" w="100%">
            Homeworks
          </Heading>
          <Grid
            templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)" }}
            gap={6}
            w="100%"
          >
            {section?.map((chapter, idx) => {
              return (
                <Link
                  to={`/homework/${chapter?.id}?name=${chapter?.name}`}
                  key={idx}
                >
                  <VStack
                    bg="#ededed"
                    borderRadius="8px"
                    alignItems="flex-start"
                    p="10px"
                    spacing="20px"
                    w="100%"
                    cursor="pointer"
                  >
                    <HStack alignItems="flex-start" w="100%">
                      <Avatar
                        name={chapter?.name}
                        src={bg}
                        borderRadius="8px"
                        size="md"
                        background="transparent"
                      />

                      <VStack alignItems="flex-start">
                        <Text fontWeight="700" fontSize="20px">
                          {chapter?.name}
                        </Text>
                      </VStack>
                    </HStack>
                  </VStack>
                </Link>
              );
            })}
          </Grid>
        </VStack>
      </Container>
    </Layout>
  );
};

export default HomeworkChaptersList;
